import { Box, BoxProps } from "@chakra-ui/react";
import * as L from "leaflet";
import { FC } from "react";
import { MapContainer, Polygon, TileLayer } from "react-leaflet";

export interface ExtentMapProps extends BoxProps {
  extent: L.LatLngBounds | null;
}

const mapBoxAccessToken =
  "pk.eyJ1IjoibmVsZW5zY2h1dXJtYW5zIiwiYSI6ImNrZWlnbHdycjFqNHMyem95cWFqNzhkc3IifQ.ymzd92iqviR5RZ-dd-xRIg";

const ExtentMap: FC<ExtentMapProps> = ({ extent, ...rest }) => {
  if (!extent) return null;

  return (
    <Box
      height="100%"
      sx={{
        "& .leaflet-control-zoom a": {
          color: "brand.analytic",
        },
        "& .leaflet-control-attribution a": {
          color: "brand.analytic",
        },
        "& .leaflet-control-attribution": {
          color: "brand.analytic",
        },
      }}
      {...rest}
    >
      <MapContainer bounds={extent} style={{ height: "100%" }}>
        <TileLayer
          url={`https://api.mapbox.com/styles/v1/nelenschuurmans/ck8sgpk8h25ql1io2ccnueuj6/tiles/256/{z}/{x}/{y}@2x?access_token=${mapBoxAccessToken}`}
        />
        <Polygon
          positions={[
            extent.getNorthWest(),
            extent.getNorthEast(),
            extent.getSouthEast(),
            extent.getSouthWest(),
          ]}
        />
      </MapContainer>
    </Box>
  );
};

export default ExtentMap;
